// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__WAX-w","text":"mimic___styles_text__+dl6O","mail":"mimic___styles_mail__FqJ8h"};